import useAuth from './../hooks/useAuth'

import UserDashboard from './dashboard/USER'
import AdminDashboard from './dashboard/ADMIN'
import ProducerDashboard from './dashboard/PRODUCER'
import BuyerDashboard from './BuyerDashboard'


export default function Dashboard() {
  const { auth } = useAuth()
  const role = auth.role[0]

  return (
    <>

      {role === 'BUYER' ? (
        <BuyerDashboard />
      ) : ('')}

      {role === 'ADMIN' ? (
        <AdminDashboard />
      ) : ('')}

      {role === 'USER' ? (
        <UserDashboard />
      ) : ('')}

      {role === 'PUBLISHER' ? (
        <UserDashboard />
      ) : ('')}

      {role === 'PRODUCER' ? (
        <ProducerDashboard />
      ) : ('')}

    </>
  )
}
